import { render, staticRenderFns } from "./bar-order-menu-slidebar.vue?vue&type=template&id=7921334c&"
import script from "./bar-order-menu-slidebar.vue?vue&type=script&lang=ts&"
export * from "./bar-order-menu-slidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports